import {Button, Card, Space, Typography,} from "antd";
import {ArrowLeftOutlined, EnvironmentOutlined,} from "@ant-design/icons";
import {URLS} from "@/lib/urls";
import {Link, useSearchParams} from "react-router-dom";
import LockMap from "@/components/map/LockMap";

const {Title, Text} = Typography;

export default function LockMapBanner({item}) {

    const [searchParams, setSearchParams] = useSearchParams();

    const chooseLocationButton = (<Link to={URLS.student.lessons.map + '?' + searchParams.toString()}>
            <Button
                type="primary"
                size="large"
                icon={<EnvironmentOutlined/>}
                className="mt-3 h-12 rounded-xl !border-0 !bg-white !font-semibold !text-[#1677ff]"
            >
                انتخاب کلاس دیگر از روی نقشه
                <ArrowLeftOutlined/>
            </Button>
        </Link>
    )

    return (
        <Card
            className="mb-6 overflow-hidden rounded-[20px] border-0 bg-gradient-to-br from-[#1677ff] to-[#69b1ff] "

        >
            <div className="flex flex-wrap items-center justify-between gap-6">
                <div className="min-w-[280px] flex-1">
                    <Space direction="vertical" size={8}>
                        <Title level={3} className="!m-0 !text-white">
                            کلاس‌های فعال در
                            <span className={'mx-1 font-bold'}>{item?.title}</span>
                            <div>

                                <div className="flex flex-wrap gap-1">
                                    {/*<div>{item?.street}</div>*/}
                                    <div>{item?.address}</div>
                                </div>


                            </div>
                        </Title>

                        <Text className="text-base !text-white/90">
                            در این صفحه کلاس‌های فعال در این موقعیت مکانی را مشاهده میکنید
                        </Text>
                        <div className={'hidden md:flex'}>
                            {chooseLocationButton}
                        </div>

                    </Space>
                </div>

                <div className="h-[200px] w-[200px] overflow-hidden rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.15)]">
                    <div className={'w-[200px] h-[200px]'}>

                        <LockMap point={item} zoom={16}/>
                    </div>
                </div>
                <div className={'flex md:hidden w-full'}>
                    {chooseLocationButton}
                </div>
            </div>
        </Card>
    );
}
